var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-listado-contrato-garantias"}},[[_c('desktop',{attrs:{"listadoGarantias":_vm.listadoGarantias}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }